import baseAPI from "@/api/base";
import { EditProfile, GetUser, RegisterUser } from "@/dtos/user.dto";
import { USER_PROFILE_URL, USER_TEAM_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

class User {
    // GET /user/team — the members of the signed-in user's organization.
    static getUsers = async (params?: GetUser): Promise<AxiosResponse> => {
        return baseAPI.get(USER_TEAM_URL, { params });
    };

    // POST /user/team — add a member to the organization.
    static registerUser = async (body: RegisterUser): Promise<AxiosResponse> => {
        return baseAPI.post(USER_TEAM_URL, body);
    };

    // DELETE /user/team/:id — remove (soft-delete) a member.
    static deleteUser = async (id: string): Promise<AxiosResponse> => {
        return baseAPI.delete(`${USER_TEAM_URL}/${id}`);
    };

    // PUT /user/profile — the signed-in user updates their own details.
    static updateProfile = async (body: EditProfile): Promise<AxiosResponse> => {
        return baseAPI.put(USER_PROFILE_URL, body);
    };
}

export default User;
